
export default function Redirect({to}: {to: string}) {
    return <>{window.location.assign(to)}</>;
}